import React, { useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import "../../styles/newbusiness.css";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../helper/api";
import { getServerURL } from "../../helper/envConfig";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
const RequestOnlineTraining = () => {
  const { t } = useTranslation("RequestOnlineTraining");

  const serverURL = getServerURL();

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    company: "",
    topic: "",
    preferred_format: "online",
    date: "",
    participants: 0,
    objective: "",
    comment: "",
    address: "",
    location: "",
    city: "",
    country: "germany",
    platform: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!formData.full_name) {
  toast.error(t("full_name_required"));
  return;
}
if (!formData.email) {
  toast.error(t("email_required"));
  return;
}
if (!formData.company) {
  toast.error(t("company_required"));
  return;
}
if (!formData.topic) {
  toast.error(t("topic_required"));
  return;
}
if (!formData.date) {
  toast.error(t("date_required"));
  return;
}
if (formData.participants <= 0) {
  toast.error(t("participants_greater_than_zero"));
  return;
}
if (!formData.objective) {
  toast.error(t("objective_required"));
  return;
}

if (formData.preferred_format === "onsite") {
  if (!formData.address) {
    toast.error(t("address_required"));
    return;
  }
  if (!formData.location) {
    toast.error(t("location_required"));
    return;
  }
  if (!formData.city) {
    toast.error(t("city_required"));
    return;
  }
  if (!formData.country) {
    toast.error(t("country_required"));
    return;
  }
}

if (formData.preferred_format === "online") {
  if (!formData.platform) {
    toast.error(t("platform_required"));
    return;
  }
}

      const res = await api.post(
        serverURL + `users/training-request/`,
        formData
      );
      if (res.data.success) {
        toast.success(res.data.message);
        setFormData({
          full_name: "",
          email: "",
          company: "",
          topic: "",
          preferred_format: "online",
          date: "",
          participants: 0,
          objective: "",
          comment: "",
          address: "",
          location: "",
          city: "",
          country: "germany",
          platform: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Header />
      <main className="business_public_spaces">
        <section className="business_case_study position-relative">
          <div className="container">
            <div className="row justify-content-center w-100 w-sm-100 pt-4 pt-lg-0">
              <div className="col-12 col-xl-10 d-flex justify-content-center align-items-center order-2 order-md-1">
                <div className="right_side_information request-training request-online-training">
                  <h6>{t("requestanonlineoronsitetraining")} </h6>
                  <div className="mt-4 mt-md-4 mt-lg-5">
                    <Form className="row justify-content-center g-4">
                      <div className="col-12 col-md-6">
                        <h3>{t("requesterinformation")} </h3>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("fullname")} </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={t("enterfullnametext")}
                            name={"full_name"}
                            value={formData.full_name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label> {t("emailaddress")}</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder={t("emailtext")}
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("companyorganization")}</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={t("entercompanynametext")}
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                          />
                        </Form.Group>
                        <h3>{t("trainingdetails")}</h3>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("trainingtopic")}</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={t("entertrainingtext")}
                            name="topic"
                            value={formData.topic}
                            onChange={handleChange}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("preferredformat")} </Form.Label>
                          <Form.Select
                            aria-label={t("defaultselectexampletext")}
                            value={formData.preferred_format}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                preferred_format: e.target.value,
                              });
                            }}
                          >
                            <option value="online">{t("online")}</option>
                            <option value="onsite">{t("onsite")}</option>
                          </Form.Select>
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("preferreddates")} </Form.Label>
                          <Form.Control
                            type="date"
                            placeholder={t("entertrainingtext")}
                            name="date"
                            value={formData?.date}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-12 col-md-6">
                        {formData.preferred_format === "onsite" && (
                          <>
                            <h3>{t("locationdetails")}</h3>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Control
                                type="text"
                                placeholder={t("enterstreetaddresstext")}
                                name="address"
                                value={formData?.address}
                                onChange={handleChange}
                              />
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Control
                                type="text"
                                placeholder={t("enteraptsuitetext")}
                                name="location"
                                value={formData?.location}
                                onChange={handleChange}
                              />
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Control
                                type="text"
                                placeholder={t("entercitytext")}
                                name="city"
                                value={formData?.city}
                                onChange={handleChange}
                              />
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Form.Select
                                aria-label={t("defaultselectexampletext")}
                                value={formData?.country}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e.target.value,
                                  });
                                }}
                              >
                                <option value="afghanistan">
                                  {t("afghanistan")}
                                </option>
                                <option value="albania">{t("albania")}</option>
                                <option value="algeria">{t("algeria")}</option>
                                <option value="american_samoa">
                                  {t("americansamoa")}
                                </option>
                                <option value="andorra">{t("andorra")}</option>
                                <option value="angola">{t("angola")}</option>
                                <option value="anguilla">
                                  {t("anguilla")}
                                </option>
                                <option value="antigua_and_barbuda">
                                  {t("antiguaandbarbuda")}
                                </option>
                                <option value="argentina">
                                  {t("argentina")}
                                </option>
                                <option value="armenia">{t("armenia")}</option>
                                <option value="aruba">{t("aruba")}</option>
                                <option value="australia">
                                  {t("australia")}
                                </option>
                                <option value="austria">{t("austria")}</option>
                                <option value="azerbaijan">
                                  {t("azerbaijan")}
                                </option>
                                <option value="bahamas">{t("bahamas")}</option>
                                <option value="bahrain">{t("bahrain")}</option>
                                <option value="bangladesh">
                                  {t("bangladesh")}
                                </option>
                                <option value="barbados">
                                  {t("barbados")}
                                </option>
                                <option value="belarus">{t("belarus")}</option>
                                <option value="belgium">{t("belgium")}</option>
                                <option value="belize">{t("belize")}</option>
                                <option value="benin">{t("benin")}</option>
                                <option value="bermuda">{t("bermuda")}</option>
                                <option value="bhutan">{t("bhutan")}</option>
                                <option value="bolivia">{t("bolivia")}</option>
                                <option value="bosnia_and_herzegovina">
                                  {t("bosniaandherzegovina")}
                                </option>
                                <option value="botswana">
                                  {t("botswana")}
                                </option>
                                <option value="brazil">{t("brazil")}</option>
                                <option value="british_indian_ocean_territory">
                                  {t("britishindianoceanterritory")}
                                </option>
                                <option value="brunei_darussalam">
                                  {t("bruneidarussalam")}
                                </option>
                                <option value="bulgaria">
                                  {t("bulgaria")}
                                </option>
                                <option value="burkina_faso">
                                  {t("burkinafaso")}
                                </option>
                                <option value="burundi">{t("burundi")}</option>
                                <option value="cambodia">
                                  {t("cambodia")}
                                </option>
                                <option value="cameroon">
                                  {t("cameroon")}
                                </option>
                                <option value="canada">{t("canada")}</option>
                                <option value="cape_verde">
                                  {t("capeverde")}
                                </option>
                                <option value="cayman_islands">
                                  {t("caymanislands")}
                                </option>
                                <option value="central_african_republic">
                                  {t("centralafricanrepublic")}
                                </option>
                                <option value="chad">{t("chad")}</option>
                                <option value="chile">{t("chile")}</option>
                                <option value="china">{t("china")}</option>
                                <option value="christmas_island">
                                  {t("christmasisland")}
                                </option>
                                <option value="cocos_keeling_islands">
                                  {t("cocoskeelingislands")}
                                </option>
                                <option value="colombia">
                                  {t("colombia")}
                                </option>
                                <option value="comoros">{t("comoros")}</option>
                                <option value="congo">{t("congo")}</option>
                                <option value="congo_democratic_republic">
                                  {t("congodemocraticrepublic")}
                                </option>
                                <option value="cook_islands">
                                  {t("cookislands")}
                                </option>
                                <option value="costa_rica">
                                  {t("costarica")}
                                </option>
                                <option value="croatia">{t("croatia")}</option>
                                <option value="cuba">{t("cuba")}</option>
                                <option value="cyprus">{t("cyprus")}</option>
                                <option value="czech_republic">
                                  {t("czechrepublic")}
                                </option>
                                <option value="cote_divoire">
                                  {t("côtedivoire")}
                                </option>
                                <option value="denmark">{t("denmark")}</option>
                                <option value="djibouti">
                                  {t("djibouti")}
                                </option>
                                <option value="dominica">
                                  {t("dominica")}
                                </option>
                                <option value="dominican_republic">
                                  {t("dominicanrepublic")}
                                </option>
                                <option value="ecuador">{t("ecuador")}</option>
                                <option value="egypt">{t("egypt")}</option>
                                <option value="el_salvador">
                                  {t("elsalvador")}
                                </option>
                                <option value="equatorial_guinea">
                                  {t("equatorialguinea")}
                                </option>
                                <option value="eritrea">{t("eritrea")}</option>
                                <option value="estonia">{t("estonia")}</option>
                                <option value="ethiopia">
                                  {t("ethiopia")}
                                </option>
                                <option value="falkland_islands_malvinas">
                                  {t("falklandislandsmalvinas")}
                                </option>
                                <option value="faroe_islands">
                                  {t("faroeislands")}
                                </option>
                                <option value="fiji">{t("fiji")}</option>
                                <option value="finland">{t("finland")}</option>
                                <option value="france">{t("france")}</option>
                                <option value="french_guiana">
                                  {t("frenchguiana")}
                                </option>
                                <option value="french_polynesia">
                                  {t("frenchpolynesia")}
                                </option>
                                <option value="french_southern_territories">
                                  {t("frenchsouthernterritories")}
                                </option>
                                <option value="gabon">{t("gabon")}</option>
                                <option value="gambia">{t("gambia")}</option>
                                <option value="georgia">{t("georgia")}</option>
                                <option value="germany">{t("germany")}</option>
                                <option value="ghana">{t("ghana")}</option>
                                <option value="gibraltar">
                                  {t("gibraltar")}
                                </option>
                                <option value="greece">{t("greece")}</option>
                                <option value="greenland">
                                  {t("greenland")}
                                </option>
                                <option value="grenada">{t("grenada")}</option>
                                <option value="guadeloupe">
                                  {t("guadeloupe")}
                                </option>
                                <option value="guam">{t("guam")}</option>
                                <option value="guatemala">
                                  {t("guatemala")}
                                </option>
                                <option value="guernsey">
                                  {t("guernsey")}
                                </option>
                                <option value="guinea">{t("guinea")}</option>
                                <option value="guinea_bissau">
                                  {t("guineabissau")}
                                </option>
                                <option value="guyana">{t("guyana")}</option>
                                <option value="haiti">{t("haiti")}</option>
                                <option value="heard_island_and_mcdonald_islands">
                                  {t("heardislandandmcdonaldislands")}
                                </option>
                                <option value="honduras">
                                  {t("honduras")}
                                </option>
                                <option value="hong_kong">
                                  {t("hongkong")}
                                </option>
                                <option value="hungary">{t("hungary")}</option>
                                <option value="iceland">{t("iceland")}</option>
                                <option value="india">{t("india")}</option>
                                <option value="indonesia">
                                  {t("indonesia")}
                                </option>
                                <option value="iran">{t("iran")}</option>
                                <option value="iraq">{t("iraq")}</option>
                                <option value="ireland">{t("ireland")}</option>
                                <option value="isle_of_man">
                                  {t("isleofman")}
                                </option>
                                <option value="israel">{t("israel")}</option>
                                <option value="italy">{t("italy")}</option>
                                <option value="jamaica">{t("jamaica")}</option>
                                <option value="japan">{t("japan")}</option>
                                <option value="jersey">{t("jersey")}</option>
                                <option value="jordan">{t("jordan")}</option>
                                <option value="kazakhstan">
                                  {t("kazakhstan")}
                                </option>
                                <option value="kenya">{t("kenya")}</option>
                                <option value="kiribati">
                                  {t("kiribati")}
                                </option>
                                <option value="kuwait">{t("kuwait")}</option>
                                <option value="kyrgyzstan">
                                  {t("kyrgyzstan")}
                                </option>
                                <option value="lao_peoples_democratic_republic">
                                  {t("laopeoplesdemocraticrepublic")}
                                </option>
                                <option value="latvia">{t("latvia")}</option>
                                <option value="lebanon">{t("lebanon")}</option>
                                <option value="lesotho">{t("lesotho")}</option>
                                <option value="liberia">{t("liberia")}</option>
                                <option value="libya">{t("libya")}</option>
                                <option value="liechtenstein">
                                  {t("liechtenstein")}
                                </option>
                                <option value="lithuania">
                                  {t("lithuania")}
                                </option>
                                <option value="luxembourg">
                                  {t("luxembourg")}
                                </option>
                                <option value="macao">{t("macao")}</option>
                                <option value="macedonia">
                                  {t("macedonia")}
                                </option>
                                <option value="madagascar">
                                  {t("madagascar")}
                                </option>
                                <option value="malawi">{t("malawi")}</option>
                                <option value="malaysia">
                                  {t("malaysia")}
                                </option>
                                <option value="maldives">
                                  {t("maldives")}
                                </option>
                                <option value="mali">{t("mali")}</option>
                                <option value="malta">{t("malta")}</option>
                                <option value="marshall_islands">
                                  {t("marshallislands")}
                                </option>
                                <option value="martinique">
                                  {t("martinique")}
                                </option>
                                <option value="mauritania">
                                  {t("mauritania")}
                                </option>
                                <option value="mauritius">
                                  {t("mauritius")}
                                </option>
                                <option value="mayotte">{t("mayotte")}</option>
                                <option value="mexico">{t("mexico")}</option>
                                <option value="micronesia_federated_states_of">
                                  {t("micronesiafederatedstatesof")}
                                </option>
                                <option value="moldova">{t("moldova")}</option>
                                <option value="monaco">{t("monaco")}</option>
                                <option value="mongolia">
                                  {t("mongolia")}
                                </option>
                                <option value="montenegro">
                                  {t("montenegro")}
                                </option>
                                <option value="montserrat">
                                  {t("montserrat")}
                                </option>
                                <option value="morocco">{t("morocco")}</option>
                                <option value="mozambique">
                                  {t("mozambique")}
                                </option>
                                <option value="myanmar">{t("myanmar")}</option>
                                <option value="namibia">{t("namibia")}</option>
                                <option value="nauru">{t("nauru")}</option>
                                <option value="nepal">{t("nepal")}</option>
                                <option value="netherlands">
                                  {t("netherlands")}
                                </option>
                                <option value="newcaledonia">
                                  {t("newcaledonia")}
                                </option>
                                <option value="newzealand">
                                  {t("newzealand")}
                                </option>
                                <option value="nicaragua">
                                  {t("nicaragua")}
                                </option>
                                <option value="niger">{t("niger")}</option>
                                <option value="nigeria">{t("nigeria")}</option>
                                <option value="niue">{t("niue")}</option>
                                <option value="norfolkisland">
                                  {t("norfolkisland")}
                                </option>
                                <option value="northkorea">
                                  {t("northkorea")}
                                </option>
                                <option value="northernmarianaislands">
                                  {t("northernmarianaislands")}
                                </option>
                                <option value="norway">{t("norway")}</option>
                                <option value="oman">{t("oman")}</option>
                                <option value="pakistan">
                                  {t("pakistan")}
                                </option>
                                <option value="palau">{t("palau")}</option>
                                <option value="palestinianterritory">
                                  {t("palestinianterritory")}
                                </option>
                                <option value="panama">{t("panama")}</option>
                                <option value="papuanewguinea">
                                  {t("papuanewguinea")}
                                </option>
                                <option value="paraguay">
                                  {t("paraguay")}
                                </option>
                                <option value="peru">{t("peru")}</option>
                                <option value="philippines">
                                  {t("philippines")}
                                </option>
                                <option value="pitcairnislands">
                                  {t("pitcairnislands")}
                                </option>
                                <option value="poland">{t("poland")}</option>
                                <option value="portugal">
                                  {t("portugal")}
                                </option>
                                <option value="puertorico">
                                  {t("puertorico")}
                                </option>
                                <option value="qatar">{t("qatar")}</option>
                                <option value="réunion">{t("réunion")}</option>
                                <option value="romania">{t("romania")}</option>
                                <option value="russia">{t("russia")}</option>
                                <option value="rwanda">{t("rwanda")}</option>
                                <option value="saintbarthélemy">
                                  {t("saintbarthélemy")}
                                </option>
                                <option value="sainthelena">
                                  {t("sainthelena")}
                                </option>
                                <option value="saintkittsandnevis">
                                  {t("saintkittsandnevis")}
                                </option>
                                <option value="saintlucia">
                                  {t("saintlucia")}
                                </option>
                                <option value="saintmartin">
                                  {t("saintmartin")}
                                </option>
                                <option value="sintmaarten">
                                  {t("sintmaarten")}
                                </option>
                                <option value="saintpierreandmiquelon">
                                  {t("saintpierreandmiquelon")}
                                </option>
                                <option value="saintvincentandthegrenadines">
                                  {t("saintvincentandthegrenadines")}
                                </option>
                                <option value="samoa">{t("samoa")}</option>
                                <option value="sanmarino">
                                  {t("sanmarino")}
                                </option>
                                <option value="saotomeandprincipe">
                                  {t("saotomeandprincipe")}
                                </option>
                                <option value="saudiarabia">
                                  {t("saudiarabia")}
                                </option>
                                <option value="senegal">{t("senegal")}</option>
                                <option value="serbia">{t("serbia")}</option>
                                <option value="seychelles">
                                  {t("seychelles")}
                                </option>
                                <option value="sierraleone">
                                  {t("sierraleone")}
                                </option>
                                <option value="singapore">
                                  {t("singapore")}
                                </option>
                                <option value="slovakia">
                                  {t("slovakia")}
                                </option>
                                <option value="slovenia">
                                  {t("slovenia")}
                                </option>
                                <option value="solomonislands">
                                  {t("solomonislands")}
                                </option>
                                <option value="somalia">{t("somalia")}</option>
                                <option value="southafrica">
                                  {t("southafrica")}
                                </option>
                                <option value="southgeorgiaandthesouthsandwichislands">
                                  {t("southgeorgiaandthesouthsandwichislands")}
                                </option>
                                <option value="southkorea">
                                  {t("southkorea")}
                                </option>
                                <option value="spain">{t("spain")}</option>
                                <option value="srilanka">
                                  {t("srilanka")}
                                </option>
                                <option value="sudan">{t("sudan")}</option>
                                <option value="suriname">
                                  {t("suriname")}
                                </option>
                                <option value="svalbardandjanmayen">
                                  {t("svalbardandjanmayen")}
                                </option>
                                <option value="swaziland">
                                  {t("swaziland")}
                                </option>
                                <option value="sweden">{t("sweden")}</option>
                                <option value="switzerland">
                                  {t("switzerland")}
                                </option>
                                <option value="syria">{t("syria")}</option>
                                <option value="taiwan">{t("taiwan")}</option>
                                <option value="tajikistan">
                                  {t("tajikistan")}
                                </option>
                                <option value="tanzania">
                                  {t("tanzania")}
                                </option>
                                <option value="thailand">
                                  {t("thailand")}
                                </option>
                                <option value="timorleste">
                                  {t("timorleste")}
                                </option>
                                <option value="togo">{t("togo")}</option>
                                <option value="tokelau">{t("tokelau")}</option>
                                <option value="tonga">{t("tonga")}</option>
                                <option value="trinidadandtobago">
                                  {t("trinidadandtobago")}
                                </option>
                                <option value="tunisia">{t("tunisia")}</option>
                                <option value="turkey">{t("turkey")}</option>
                                <option value="turkmenistan">
                                  {t("turkmenistan")}
                                </option>
                                <option value="turksandcaicosislands">
                                  {t("turksandcaicosislands")}
                                </option>
                                <option value="tuvalu">{t("tuvalu")}</option>
                                <option value="uganda">{t("uganda")}</option>
                                <option value="ukraine">{t("ukraine")}</option>
                                <option value="unitedarabemirates">
                                  {t("unitedarabemirates")}
                                </option>
                                <option value="unitedkingdom">
                                  {t("unitedkingdom")}
                                </option>
                                <option value="unitedstates">
                                  {t("unitedstates")}
                                </option>
                                <option value="uruguay">{t("uruguay")}</option>
                                <option value="uzbekistan">
                                  {t("uzbekistan")}
                                </option>
                                <option value="vanuatu">{t("vanuatu")}</option>
                                <option value="venezuela">
                                  {t("venezuela")}
                                </option>
                                <option value="vietnam">{t("vietnam")}</option>
                                <option value="wallisandfutuna">
                                  {t("wallisandfutuna")}
                                </option>
                                <option value="westernsahara">
                                  {t("westernsahara")}
                                </option>
                                <option value="yemen">{t("yemen")}</option>
                                <option value="zambia">{t("zambia")}</option>
                                <option value="zimbabwe">
                                  {t("zimbabwe")}
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </>
                        )}

                        {formData.preferred_format === "online" && (
                          <>
                            <h3>{t("prefreedplatform")} </h3>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Label>{t("prefreedplatform")} </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder={t("enterpreferredplatformtext")}
                                name="platform"
                                value={formData?.platform}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </>
                        )}
                        <h3>{t("participantsgoals")} </h3>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("numberofparticipants")} </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder={t("enter_number")}
                            name="participants"
                            value={formData?.participants}
                            onChange={handleChange}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>{t("keylearningobjectives")} </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={t("enter_objectives")}
                            name="objective"
                            value={formData?.objective}
                            onChange={handleChange}
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Label>
                            {t("additionalcommentsoptional")}{" "}
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="comment"
                            value={formData?.comment}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </div>
                  <div className="d-flex align-items-center gap-3 pb-3 pb-lg-5">
                    <button className="w-auto" onClick={handleSubmit}>
                      {t("requesttraining")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default RequestOnlineTraining;
